/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseError } from '../types';
// @ts-ignore
import type { CreateFolderBody } from '../types';
// @ts-ignore
import type { CreateFolderNavigationElement422Response } from '../types';
// @ts-ignore
import type { CreateLinkBody } from '../types';
// @ts-ignore
import type { NavigationElement } from '../types';
// @ts-ignore
import type { PublishedNavigationElement } from '../types';
// @ts-ignore
import type { ReorderNavigationElementsBodyInner } from '../types';
// @ts-ignore
import type { UpdateNavigationElementBody } from '../types';
/**
 * NavigationElementsApi - axios parameter creator
 * @export
 */
export const NavigationElementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new folder NavigationElement.
         * @summary Create a folder NavigationElement
         * @param {string} dashboardId 
         * @param {CreateFolderBody} [createFolderBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolderNavigationElement: async (dashboardId: string, createFolderBody?: CreateFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('createFolderNavigationElement', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/navigation_elements/folders`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new link  NavigationElement.
         * @summary Create a link NavigationElement
         * @param {string} dashboardId 
         * @param {CreateLinkBody} [createLinkBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkNavigationElement: async (dashboardId: string, createLinkBody?: CreateLinkBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('createLinkNavigationElement', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/navigation_elements/links`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLinkBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a navigation element.
         * @summary Delete an existing navigation element
         * @param {string} navigationElementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNavigationElement: async (navigationElementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'navigationElementId' is not null or undefined
            assertParamExists('deleteNavigationElement', 'navigationElementId', navigationElementId)
            const localVarPath = `/navigation_elements/{navigation_element_id}`
                .replace(`{${"navigation_element_id"}}`, encodeURIComponent(String(navigationElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns navigation elements for dashboard.
         * @summary List all navigation elements for dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationElementsForDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getNavigationElementsForDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/navigation_elements`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all navigation elements for a published dashboard.
         * @summary List all navigation elements for published dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationElementsForPublishedDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getNavigationElementsForPublishedDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/published/dashboards/{dashboard_id}/navigation_elements`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reorders all navigation elements for dashboard.
         * @summary Reorder all navigation elements for dashboard by ID
         * @param {string} dashboardId 
         * @param {Array<ReorderNavigationElementsBodyInner>} [reorderNavigationElementsBodyInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderNavigationElementsForDashboard: async (dashboardId: string, reorderNavigationElementsBodyInner?: Array<ReorderNavigationElementsBodyInner>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('reorderNavigationElementsForDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/navigation_elements/order`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderNavigationElementsBodyInner, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a navigation element.
         * @summary Update an existing navigation element
         * @param {string} navigationElementId 
         * @param {UpdateNavigationElementBody} [updateNavigationElementBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNavigationElement: async (navigationElementId: string, updateNavigationElementBody?: UpdateNavigationElementBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'navigationElementId' is not null or undefined
            assertParamExists('updateNavigationElement', 'navigationElementId', navigationElementId)
            const localVarPath = `/navigation_elements/{navigation_element_id}`
                .replace(`{${"navigation_element_id"}}`, encodeURIComponent(String(navigationElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNavigationElementBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NavigationElementsApi - functional programming interface
 * @export
 */
export const NavigationElementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NavigationElementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new folder NavigationElement.
         * @summary Create a folder NavigationElement
         * @param {string} dashboardId 
         * @param {CreateFolderBody} [createFolderBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolderNavigationElement(dashboardId: string, createFolderBody?: CreateFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NavigationElement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolderNavigationElement(dashboardId, createFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationElementsApi.createFolderNavigationElement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new link  NavigationElement.
         * @summary Create a link NavigationElement
         * @param {string} dashboardId 
         * @param {CreateLinkBody} [createLinkBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLinkNavigationElement(dashboardId: string, createLinkBody?: CreateLinkBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NavigationElement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLinkNavigationElement(dashboardId, createLinkBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationElementsApi.createLinkNavigationElement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a navigation element.
         * @summary Delete an existing navigation element
         * @param {string} navigationElementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNavigationElement(navigationElementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNavigationElement(navigationElementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationElementsApi.deleteNavigationElement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns navigation elements for dashboard.
         * @summary List all navigation elements for dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavigationElementsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NavigationElement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavigationElementsForDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationElementsApi.getNavigationElementsForDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all navigation elements for a published dashboard.
         * @summary List all navigation elements for published dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavigationElementsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublishedNavigationElement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavigationElementsForPublishedDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationElementsApi.getNavigationElementsForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reorders all navigation elements for dashboard.
         * @summary Reorder all navigation elements for dashboard by ID
         * @param {string} dashboardId 
         * @param {Array<ReorderNavigationElementsBodyInner>} [reorderNavigationElementsBodyInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderNavigationElementsForDashboard(dashboardId: string, reorderNavigationElementsBodyInner?: Array<ReorderNavigationElementsBodyInner>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderNavigationElementsForDashboard(dashboardId, reorderNavigationElementsBodyInner, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationElementsApi.reorderNavigationElementsForDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a navigation element.
         * @summary Update an existing navigation element
         * @param {string} navigationElementId 
         * @param {UpdateNavigationElementBody} [updateNavigationElementBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNavigationElement(navigationElementId: string, updateNavigationElementBody?: UpdateNavigationElementBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NavigationElement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNavigationElement(navigationElementId, updateNavigationElementBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NavigationElementsApi.updateNavigationElement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NavigationElementsApi - factory interface
 * @export
 */
export const NavigationElementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NavigationElementsApiFp(configuration)
    return {
        /**
         * Creates a new folder NavigationElement.
         * @summary Create a folder NavigationElement
         * @param {string} dashboardId 
         * @param {CreateFolderBody} [createFolderBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolderNavigationElement(dashboardId: string, createFolderBody?: CreateFolderBody, options?: RawAxiosRequestConfig): AxiosPromise<NavigationElement> {
            return localVarFp.createFolderNavigationElement(dashboardId, createFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new link  NavigationElement.
         * @summary Create a link NavigationElement
         * @param {string} dashboardId 
         * @param {CreateLinkBody} [createLinkBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLinkNavigationElement(dashboardId: string, createLinkBody?: CreateLinkBody, options?: RawAxiosRequestConfig): AxiosPromise<NavigationElement> {
            return localVarFp.createLinkNavigationElement(dashboardId, createLinkBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a navigation element.
         * @summary Delete an existing navigation element
         * @param {string} navigationElementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNavigationElement(navigationElementId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteNavigationElement(navigationElementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns navigation elements for dashboard.
         * @summary List all navigation elements for dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationElementsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NavigationElement>> {
            return localVarFp.getNavigationElementsForDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all navigation elements for a published dashboard.
         * @summary List all navigation elements for published dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavigationElementsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PublishedNavigationElement>> {
            return localVarFp.getNavigationElementsForPublishedDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reorders all navigation elements for dashboard.
         * @summary Reorder all navigation elements for dashboard by ID
         * @param {string} dashboardId 
         * @param {Array<ReorderNavigationElementsBodyInner>} [reorderNavigationElementsBodyInner] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderNavigationElementsForDashboard(dashboardId: string, reorderNavigationElementsBodyInner?: Array<ReorderNavigationElementsBodyInner>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderNavigationElementsForDashboard(dashboardId, reorderNavigationElementsBodyInner, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a navigation element.
         * @summary Update an existing navigation element
         * @param {string} navigationElementId 
         * @param {UpdateNavigationElementBody} [updateNavigationElementBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNavigationElement(navigationElementId: string, updateNavigationElementBody?: UpdateNavigationElementBody, options?: RawAxiosRequestConfig): AxiosPromise<NavigationElement> {
            return localVarFp.updateNavigationElement(navigationElementId, updateNavigationElementBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NavigationElementsApi - object-oriented interface
 * @export
 * @class NavigationElementsApi
 * @extends {BaseAPI}
 */
export class NavigationElementsApi extends BaseAPI {
    /**
     * Creates a new folder NavigationElement.
     * @summary Create a folder NavigationElement
     * @param {string} dashboardId 
     * @param {CreateFolderBody} [createFolderBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationElementsApi
     */
    public createFolderNavigationElement(dashboardId: string, createFolderBody?: CreateFolderBody, options?: RawAxiosRequestConfig) {
        return NavigationElementsApiFp(this.configuration).createFolderNavigationElement(dashboardId, createFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new link  NavigationElement.
     * @summary Create a link NavigationElement
     * @param {string} dashboardId 
     * @param {CreateLinkBody} [createLinkBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationElementsApi
     */
    public createLinkNavigationElement(dashboardId: string, createLinkBody?: CreateLinkBody, options?: RawAxiosRequestConfig) {
        return NavigationElementsApiFp(this.configuration).createLinkNavigationElement(dashboardId, createLinkBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a navigation element.
     * @summary Delete an existing navigation element
     * @param {string} navigationElementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationElementsApi
     */
    public deleteNavigationElement(navigationElementId: string, options?: RawAxiosRequestConfig) {
        return NavigationElementsApiFp(this.configuration).deleteNavigationElement(navigationElementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns navigation elements for dashboard.
     * @summary List all navigation elements for dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationElementsApi
     */
    public getNavigationElementsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return NavigationElementsApiFp(this.configuration).getNavigationElementsForDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all navigation elements for a published dashboard.
     * @summary List all navigation elements for published dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationElementsApi
     */
    public getNavigationElementsForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return NavigationElementsApiFp(this.configuration).getNavigationElementsForPublishedDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reorders all navigation elements for dashboard.
     * @summary Reorder all navigation elements for dashboard by ID
     * @param {string} dashboardId 
     * @param {Array<ReorderNavigationElementsBodyInner>} [reorderNavigationElementsBodyInner] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationElementsApi
     */
    public reorderNavigationElementsForDashboard(dashboardId: string, reorderNavigationElementsBodyInner?: Array<ReorderNavigationElementsBodyInner>, options?: RawAxiosRequestConfig) {
        return NavigationElementsApiFp(this.configuration).reorderNavigationElementsForDashboard(dashboardId, reorderNavigationElementsBodyInner, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a navigation element.
     * @summary Update an existing navigation element
     * @param {string} navigationElementId 
     * @param {UpdateNavigationElementBody} [updateNavigationElementBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NavigationElementsApi
     */
    public updateNavigationElement(navigationElementId: string, updateNavigationElementBody?: UpdateNavigationElementBody, options?: RawAxiosRequestConfig) {
        return NavigationElementsApiFp(this.configuration).updateNavigationElement(navigationElementId, updateNavigationElementBody, options).then((request) => request(this.axios, this.basePath));
    }
}

